import { SVG, SVGProps } from './svg'

export function IconRefresh(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="m8.72 12.15.2.2a.5.5 0 0 1 0 .71L5.39 16.6c-.2.2-.51.2-.71 0l-3.53-3.54a.5.5 0 0 1 0-.71l.2-.2c.1-.1.22-.15.36-.15H4a8.01 8.01 0 0 1 12-6.93c.14.08.23.22.26.37a.5.5 0 0 1-.14.42l-.74.74a.51.51 0 0 1-.59.1A6 6 0 0 0 6 12h2.36c.14 0 .27.05.36.15Zm13.93-.3.2-.2a.5.5 0 0 0 0-.71L19.32 7.4a.51.51 0 0 0-.71 0l-3.53 3.54a.5.5 0 0 0 0 .71l.2.2c.1.1.22.15.36.15H18a6 6 0 0 1-8.78 5.32.5.5 0 0 0-.59.09l-.73.73a.5.5 0 0 0-.14.42c.02.15.1.29.24.37A8 8 0 0 0 20 12h2.29c.14 0 .27-.05.36-.15Z" />
    </SVG>
  )
}
